// extracted by mini-css-extract-plugin
module.exports = {"Image":"LinkWithImage_Image__tdY1b","CardWrapper":"LinkWithImage_CardWrapper__07UZF","ImageWrapper":"LinkWithImage_ImageWrapper__rCeEC"};